import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-add-to-favorites-modal',
  templateUrl: './add-to-favorites-modal.component.html',
  styleUrl: './add-to-favorites-modal.component.scss',
  standalone: false
})
export class AddToFavoritesModalComponent implements OnInit {
  name = '';

  constructor(public activeModal: NgbActiveModal) {}

  closeModal(): void {
    this.activeModal.close();
  }

  save(name: string): void {
    this.activeModal.close(name);
  }

  ngOnInit(): void {}
}
LightningModalTypes.AddToFavoritesModal.component = AddToFavoritesModalComponent;
